'use client';

import { FC } from 'react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { useTranslations } from '@/hooks/useTranslations';
import { CreateExpenseForm } from '../create/create-expense-form';
import { useExpenseContext } from '@/contexts/expense-context';

export const CreateExpensePopup: FC = () => {
  const { dispatch, state } = useExpenseContext();

  const t = useTranslations('CreateExpensePopup');

  const handleOpenChange = (isOpen: boolean) => {
    if (isOpen) {
      dispatch({ type: 'OPEN_CREATE_EXPENSE_POPUP' });
    } else {
      dispatch({ type: 'CLOSE_CREATE_EXPENSE_POPUP' });
    }
  };

  return (
    <Sheet
      open={state.isCreateExpensePopupOpen}
      onOpenChange={handleOpenChange}
    >
      <SheetContent className="bg-white dark:bg-black">
        <SheetHeader>
          <SheetTitle className="text-left">{t('title')}</SheetTitle>
          <SheetDescription>{t('description')}</SheetDescription>
        </SheetHeader>

        <div className="grid gap-4 p-4">
          <CreateExpenseForm />
        </div>
      </SheetContent>
    </Sheet>
  );
};
